import { gql } from "@apollo/client/core";

export const GET_CHANGESET_ITEMS = gql`
    query {
        landscapeManagement {
            changeSets {
                items {
                    id,
                    name,
                    description,
                    sourceTenantId,
                    sourceTenantName
                    createdBy,
                    createdAt,
                    updatedAt,
                    lastDeployed,
                    deployedAt,
                    deployedBy,
                    status,
                    itemsCount,
                    tenantsCount,
                    changesetDetails {
                        tenantId,
                        tenant,
                        deployedAt,
                        lastDeployed,
                        include,
                        status
                    }
                },
                pageInfo {
                    hasPreviousPage,
                    hasNextPage
                },
                totalCount
            }
        }
    }
`;
